import { ResultOf } from "gql.tada";
import { ThemeModel } from "../../../types/ThemeModel";
import { RotaryCarouselSectionById } from "@queries/entries/RotaryCarouselSectionById";
import { useIsDesktop } from "@hooks/useIsDesktop";
import Carousel, { Slide } from "@components/shared/RotaryCarousel";
import { useTranslation } from "@services/i18n";
import { OBELIX_CAROUSEL_KEYS } from "@utils/obelixKeys";

export const RotaryCarouselSection = ({
  entry: { rotaryCarouselSection: entry },
}: {
  entry: ResultOf<typeof RotaryCarouselSectionById>;
}) => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation();

  if (!entry?.itemsCollection?.items?.length) {
    return null;
  }
  const slides: Slide[] = entry.itemsCollection.items.map((item) => {
    return {
      content: item?.description ?? "",
      image: item?.image?.url,
      highlightTheme: item?.theme as ThemeModel,
      sourceInfo: item?.sourceRichText,
    } as Slide;
  });

  if (!slides?.length) {
    return null;
  }
  return (
    <section className="flex flex-col gap-8 items-center justify-center dsk:py-20">
      <div className="w-full  min-h-screen flex justify-center items-center">
        <div className="min-h-max w-full">
          <Carousel
            slides={slides}
            slideWidth={isDesktop ? 564 : 280}
            slideHeight={isDesktop ? 500 : 250}
            gap={isDesktop ? 300 : 35}
            // QC-012: when the CMS a11y labels are unauthored for this
            // locale, fall back to the shared Obelix strings so the control
            // names stay in the active locale instead of rendering English
            // (or empty) aria-labels.
            accessibilityControlLabelNext={
              entry.accessibilityControlLabelNext ||
              t(OBELIX_CAROUSEL_KEYS.next.obelixKey, OBELIX_CAROUSEL_KEYS.next.label)
            }
            accessibilityControlLabelPrevious={
              entry.accessibilityControlLabelPrevious ||
              t(OBELIX_CAROUSEL_KEYS.previous.obelixKey, OBELIX_CAROUSEL_KEYS.previous.label)
            }
          />
        </div>
      </div>
    </section>
  );
};
